// src/componentsdash/Modulos/Configuracion/Modulosconfiguracion/ConfigurarCuestionario.js
import React, { useEffect, useState } from "react";
import {
  getPerfilMedico,
  updatePerfilMedico,
  getMedicoAuth,
} from "../../../../services/usuarios";
import {
  CATALOGO,
  CATALOGO_CONSULTA,
  ESPECIALIDADES,
  keysDe,
  keysDeConsulta,
  normalizeEspecialidad,
} from "../../../../services/cuestionariocatalog";
import "./ConfigurarCuestionario.css";

const SCOPES = {
  HISTORIA: "historia",
  CONSULTA: "consulta",
};

 const CAMPOS_HEREDOFAMILIARES = {
   breve: [
     {
       campo: "heredofamiliares_consolidado",
       label: "Antecedentes heredofamiliares",
     },
   ],

   detallado: [
     { campo: "heredofamiliares_madre", label: "Madre" },
     { campo: "heredofamiliares_padre", label: "Padre" },
     { campo: "heredofamiliares_hermanos", label: "Hermanos" },
     { campo: "heredofamiliares_abuelos", label: "Abuelos" },
     { campo: "heredofamiliares_otros", label: "Otros" },
   ],
 };

 const CAMPOS_NO_PATOLOGICOS = {
   breve: [
     {
       campo: "no_patologicos_consolidado",
       label: "Antecedentes personales no patológicos",
     },
   ],

   detallado: [
     { campo: "no_patologicos_origen", label: "Origen" },
     { campo: "no_patologicos_ocupacion", label: "Ocupación" },
     { campo: "no_patologicos_escolaridad", label: "Escolaridad" },
     { campo: "no_patologicos_religion", label: "Religión" },
     { campo: "no_patologicos_mascotas", label: "Mascotas" },
     { campo: "no_patologicos_viajes", label: "Viajes" },
     { campo: "no_patologicos_alimentacion", label: "Alimentación" },
     { campo: "no_patologicos_vivienda", label: "Vivienda" },
     { campo: "no_patologicos_otros", label: "Otros" },
   ],
 };

 const CAMPOS_PATOLOGICOS = {
   siempre: [
     {
       campo: "patologicos_ECD",
       label: "Enfermedades Crónico Degenerativas",
     },
     {
       campo: "patologicos_alergias",
       label: "Alergias",
     },
   ],

   breve: [
     {
       campo: "patologicos_consolidado",
       label: "Otros antecedentes patológicos",
     },
   ],

   detallado: [
     { campo: "patologicos_quirurgicos", label: "Quirúrgicos" },
     { campo: "patologicos_traumaticos", label: "Traumáticos" },
     { campo: "patologicos_hospitalizaciones", label: "Hospitalizaciones" },
     { campo: "patologicos_infectocontagiosos", label: "Infectocontagiosos" },
     { campo: "patologicos_transfusionales", label: "Transfusionales" },
     { campo: "patologicos_exantematicos", label: "Exantemáticos" },
     { campo: "patologicos_alcohol", label: "Alcohol" },
     { campo: "patologicos_tabaco", label: "Tabaco" },
     { campo: "patologicos_toxicomanias", label: "Toxicomanías" },
     { campo: "patologicos_vacunacion", label: "Vacunación" },
     {
       campo: "patologicos_ginecoObstetricosAndrologicos",
       label: "Gineco-obstétricos / Andrológicos",
     },
     { campo: "patologicos_otros", label: "Otros" },
   ],
 };

 const CAMPOS_INTERROGATORIO = {
  breve: [
    {
      campo: "interrogatorio_consolidado",
      label: "Interrogatorio por aparatos y sistemas",
    },
  ],

  detallado: [
    { campo: "sistema_nervioso", label: "Sistema nervioso" },
    { campo: "sistema_cardiovascular", label: "Sistema cardiovascular" },
    { campo: "sistema_respiratorio", label: "Sistema respiratorio" },
    { campo: "sistema_digestivo", label: "Sistema digestivo" },
    { campo: "sistema_genitourinario", label: "Sistema genitourinario" },
    { campo: "sistema_musculoesqueletico", label: "Sistema musculoesquelético" },
    { campo: "sistema_endocrino", label: "Sistema endocrino" },
    { campo: "sistema_hematologico", label: "Sistema hematológico" },
    { campo: "piel_anexos", label: "Piel y anexos" },
  ],
};

const CAMPOS_SIN_MODO = [
  {
    campo: "exploracion_fisica",
    label: "Exploración física",
  },
  {
    campo: "pronostico",
    label: "Pronóstico",
  },
  {
    campo: "planTratamiento",
    label: "Plan de tratamiento",
  },
];

const OPCIONES_PALABRA_CLAVE = [
  "plantilla",
];


 const PLACEHOLDERS_HEREDOFAMILIARES = {
   heredofamiliares_consolidado:
     "Ej. Madre con hipertensión arterial y diabetes mellitus tipo 2. Padre sin antecedentes de relevancia. Niega otros antecedentes heredofamiliares de importancia.",

   heredofamiliares_madre:
     "Ej. Hipertensión arterial y diabetes mellitus tipo 2.",

   heredofamiliares_padre:
     "Ej. Sin antecedentes de relevancia.",

   heredofamiliares_hermanos:
     "Ej. Dos hermanos aparentemente sanos.",

   heredofamiliares_abuelos:
     "Ej. Abuelo materno con diabetes mellitus tipo 2.",

   heredofamiliares_otros:
     "Ej. Niega otros antecedentes heredofamiliares de importancia.",
 };

  const PLACEHOLDERS_NO_PATOLOGICOS = {
   no_patologicos_consolidado:
     "Ej. Originario de Ciudad de México, profesionista, licenciatura concluida, religión católica, convivencia con mascotas, sin viajes recientes, alimentación variada y vivienda con servicios completos.",

   no_patologicos_origen:
     "Ej. Ciudad de México.",

   no_patologicos_ocupacion:
     "Ej. Contador.",

   no_patologicos_escolaridad:
     "Ej. Licenciatura concluida.",

   no_patologicos_religion:
     "Ej. Católica.",

   no_patologicos_mascotas:
     "Ej. Convive con un perro vacunado.",

   no_patologicos_viajes:
     "Ej. Niega viajes recientes.",

   no_patologicos_alimentacion:
     "Ej. Alimentación variada, tres comidas al día.",

   no_patologicos_vivienda:
     "Ej. Vivienda urbana con agua potable, drenaje y electricidad.",

   no_patologicos_otros:
     "Ej. Niega otros antecedentes personales no patológicos de relevancia.",
 };

 const PLACEHOLDERS_PATOLOGICOS = {
   patologicos_ECD:
     "Ej. Hipertensión arterial sistémica de 8 años de evolución, en tratamiento y control.",

   patologicos_alergias:
     "Ej. Niega alergias conocidas.",

   patologicos_consolidado:
     "Ej. Niega antecedentes quirúrgicos, traumáticos, hospitalizaciones, enfermedades infectocontagiosas, transfusiones, exantemáticas y toxicomanías. Esquema de vacunación completo.",

   patologicos_quirurgicos:
     "Ej. Apendicectomía en 2018, sin complicaciones.",

   patologicos_traumaticos:
     "Ej. Niega antecedentes traumáticos de relevancia.",

   patologicos_hospitalizaciones:
     "Ej. Niega hospitalizaciones previas.",

   patologicos_infectocontagiosos:
     "Ej. Niega enfermedades infectocontagiosas de relevancia.",

   patologicos_transfusionales:
     "Ej. Niega antecedentes transfusionales.",

   patologicos_exantematicos:
     "Ej. Varicela durante la infancia, sin complicaciones.",

   patologicos_alcohol:
     "Ej. Consumo ocasional de alcohol.",

   patologicos_tabaco:
     "Ej. Niega tabaquismo.",

   patologicos_toxicomanias:
     "Ej. Niega uso de drogas.",

   patologicos_vacunacion:
     "Ej. Esquema de vacunación completo para la edad.",

   patologicos_ginecoObstetricosAndrologicos:
     "Ej. Sin antecedentes gineco-obstétricos o andrológicos de relevancia.",

   patologicos_otros:
     "Ej. Niega otros antecedentes personales patológicos de relevancia.",
 };

 const PLACEHOLDERS_INTERROGATORIO = {
  interrogatorio_consolidado:
  "Ej. Interrogatorio por aparatos y sistemas sin datos patológicos relevantes: niega cefalea, mareo, síncope, parestesias o déficit neurológico; dolor torácico, palpitaciones o edema; tos, disnea o expectoración; náusea, vómito, dolor abdominal o alteraciones del hábito intestinal; disuria, polaquiuria, urgencia o hematuria; artralgias, mialgias o limitación funcional; poliuria, polidipsia, intolerancia al frío o calor o cambios de peso no intencionados; sangrado anormal, equimosis o adenopatías; así como lesiones cutáneas, prurito o alteraciones en piel y anexos.",
  
  sistema_nervioso:
    "Ej. Niega cefalea, mareo, síncope, parestesias, alteraciones de la marcha o pérdida de fuerza.",

  sistema_cardiovascular:
    "Ej. Niega dolor torácico, palpitaciones, síncope, edema o disnea de esfuerzo.",

  sistema_respiratorio:
    "Ej. Niega tos, disnea, expectoración, sibilancias o dolor torácico de origen respiratorio.",

  sistema_digestivo:
    "Ej. Niega náusea, vómito, dolor abdominal, distensión, diarrea, estreñimiento o sangrado gastrointestinal.",

  sistema_genitourinario:
    "Ej. Niega disuria, polaquiuria, urgencia urinaria, hematuria o cambios en el hábito urinario.",

  sistema_musculoesqueletico:
    "Ej. Niega artralgias, mialgias, limitación funcional, inflamación o debilidad muscular.",

  sistema_endocrino:
    "Ej. Niega poliuria, polidipsia, intolerancia al frío o calor y cambios de peso no intencionados.",

  sistema_hematologico:
    "Ej. Niega sangrado anormal, equimosis espontáneas, adenopatías o palidez.",

  piel_anexos:
    "Ej. Niega lesiones cutáneas, prurito, cambios de pigmentación, caída anormal de cabello o alteraciones ungueales.",
};

const PLACEHOLDERS_SIN_MODO = {
  exploracion_fisica:
    "Ej. Paciente consciente, orientado y cooperador. Buen estado general, hidratación adecuada, sin datos de dificultad respiratoria. Exploración física sin hallazgos relevantes.",

   pronostico:
     "Ej. Pronóstico favorable para la vida y la función, sujeto a evolución clínica.",

   planTratamiento:
     "Ej. Solicitar estudios de laboratorio de control, continuar tratamiento indicado, reforzar medidas generales y citar a seguimiento.",
 };

 const RUBROS_CONFIG = [
  { id: "config-historia", label: "Historia clínica" },
  { id: "config-plantillas", label: "Plantillas rápidas" },
  { id: "config-opcionales", label: "Preguntas opcionales" },
  { id: "config-historicos", label: "Sugerencias históricas" },
];

const scrollToConfig = (id) => {
  const el = document.getElementById(id);

  if (el) {
    el.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};


export default function ConfigurarCuestionario() {
  const [loading, setLoading] = useState(true);
  const [perfil, setPerfil] = useState(null);
  const [especialidad, setEspecialidad] = useState(null);

  // pestaña actual: historia | consulta
  const [scope, setScope] = useState(SCOPES.HISTORIA);

  // ✅ borradores independientes (no se pierden al cambiar de tab)
  const [seleccionHistoria, setSeleccionHistoria] = useState(new Set());
  const [seleccionConsulta, setSeleccionConsulta] = useState(new Set());

  // alias según pestaña activa
  const seleccion =
    scope === SCOPES.HISTORIA ? seleccionHistoria : seleccionConsulta;
  const setSeleccionActual =
    scope === SCOPES.HISTORIA ? setSeleccionHistoria : setSeleccionConsulta;


  // UI flags
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState(null);
  const [error, setError] = useState(null);
  const [nom024, setNom024] = useState(false);
  const [nom004, setNom004] = useState(false);
  const [showOpcionales, setShowOpcionales] = useState(false);
  const [openSubs, setOpenSubs] = useState(new Set());
    // Sugerencias históricas
  const [showHistoricosOcultos, setShowHistoricosOcultos] = useState(false);
  const [openHistoricos, setOpenHistoricos] = useState(new Set());
  const [captureModesHistoria, setCaptureModesHistoria] = useState({
   heredofamiliares: "breve",
    no_patologicos: "breve",
    patologicos: "breve",
    interrogatorio: "breve",
 });
 const [plantillasHabilitadas, setPlantillasHabilitadas] = useState(false);
 const [plantillasPersonalizadas, setPlantillasPersonalizadas] = useState([]);
 const [sugerenciasHistoricasHabilitadas,setSugerenciasHistoricasHabilitadas] = useState(true);
 const [configSugerenciasHistoricas, setConfigSugerenciasHistoricas] = useState({});

  // Carga base (médico + perfil)
  useEffect(() => {
    let vivo = true;
    (async () => {
      try {
        setLoading(true);
        const [m, p] = await Promise.all([getMedicoAuth(), getPerfilMedico()]);
        if (!vivo) return;
        setPerfil(p || {});
        setEspecialidad(m?.especialidad || null);
        setNom024(p?.nom024 ?? false);
        setNom004(p?.nom004 ?? false);
        setPlantillasHabilitadas(p?.plantillas_habilitadas ?? false);
        setPlantillasPersonalizadas(
          Array.isArray(p?.plantillas_personalizadas)
            ? p.plantillas_personalizadas
            : []
        );
        setSugerenciasHistoricasHabilitadas(
          p?.sugerencias_historicas_habilitadas ?? true
        );

        setConfigSugerenciasHistoricas(
          p?.config_sugerencias_historicas &&
          typeof p.config_sugerencias_historicas === "object"
            ? p.config_sugerencias_historicas
            : {}
        );
      } catch (e) {
        console.error(e);
        setError("No se pudo cargar tu perfil. Intenta más tarde.");
      } finally {
        if (vivo) setLoading(false);
      }
    })();
    return () => {
      vivo = false;
    };
  }, []);

  // ✅ Inicializa ambos borradores UNA sola vez con perfil/especialidad (no depende de scope)
  useEffect(() => {
    if (!perfil) return;

    const cfg = perfil?.config_cuestionario || {};
    const enabledFromSeed = Array.isArray(cfg?.historia)
      ? cfg.historia.find((s) => s && s.enabled)?.key
      : null;

    const espNorm = normalizeEspecialidad(especialidad);
    const savedCaptureModesHistoria =
      cfg?.custom?.historia?.capture_modes || {};

    const fallback = Object.keys(cfg).length > 0 ? "detallado" : "breve";


   setCaptureModesHistoria({
  heredofamiliares:
    savedCaptureModesHistoria?.heredofamiliares || fallback,
  no_patologicos:
    savedCaptureModesHistoria?.no_patologicos || fallback,
  patologicos:
    savedCaptureModesHistoria?.patologicos || fallback,
  interrogatorio:
    savedCaptureModesHistoria?.interrogatorio || fallback,
});

    // HISTORIA: si hay guardadas, úsalas. Si no, vacío.
    const savedHistoria = cfg?.custom?.historia?.selected_keys;
    const initHistoria = Array.isArray(savedHistoria) ? savedHistoria
      : (Array.isArray(cfg?.custom?.selected_keys) ? cfg.custom.selected_keys
      : []);
    setSeleccionHistoria(new Set(initHistoria));

    // CONSULTA: si hay guardadas, úsalas. Si no, vacío.
    const savedConsulta = cfg?.custom?.consulta?.selected_keys;
    const initConsulta = Array.isArray(savedConsulta) ? savedConsulta : [];
    setSeleccionConsulta(new Set(initConsulta));
  }, [perfil, especialidad]);

  // Lista visible según chips + búsqueda (si no hay chips, se muestran todas)
  const camposPlantillaHeredofamiliares =
  CAMPOS_HEREDOFAMILIARES[captureModesHistoria.heredofamiliares] || [];

  const camposPlantillaNoPatologicos =
   CAMPOS_NO_PATOLOGICOS[captureModesHistoria.no_patologicos] || [];
  
  const camposPlantillaPatologicos = [
    ...CAMPOS_PATOLOGICOS.siempre,
    ...(CAMPOS_PATOLOGICOS[captureModesHistoria.patologicos] || []),
  ];

   const camposPlantillaInterrogatorio =
  CAMPOS_INTERROGATORIO[captureModesHistoria.interrogatorio] || [];

  const camposPlantilla = [
   ...camposPlantillaHeredofamiliares,
   ...camposPlantillaNoPatologicos,
   ...camposPlantillaPatologicos,
   ...camposPlantillaInterrogatorio,
   ...CAMPOS_SIN_MODO,
 ];


  const obtenerPlaceholderPlantilla = (campo) =>
    PLACEHOLDERS_HEREDOFAMILIARES[campo] ||
    PLACEHOLDERS_NO_PATOLOGICOS[campo] ||
    PLACEHOLDERS_PATOLOGICOS[campo] ||
    PLACEHOLDERS_INTERROGATORIO[campo] ||
     PLACEHOLDERS_SIN_MODO[campo] ||
    "Ej. Escribe aquí el texto que utilizas con frecuencia.";

  const obtenerModoPlantilla = (campo) => {
   if (campo.startsWith("heredofamiliares_")) {
     return captureModesHistoria.heredofamiliares;
   }

  if (campo.startsWith("no_patologicos_")) {
    return captureModesHistoria.no_patologicos;
  }

  if (campo.startsWith("patologicos_")) {
    return captureModesHistoria.patologicos;
   }


   return captureModesHistoria.interrogatorio;
 };
 
  const obtenerPlantillaCampo = (campo) => {
  return (
        plantillasPersonalizadas.find((plantilla) => plantilla?.campo === campo) || null
      );
    };

    const actualizarPlantillaCampo = (campo, propiedad, valor) => {
      setPlantillasPersonalizadas((prev) => {
        const lista = Array.isArray(prev) ? [...prev] : [];
        const index = lista.findIndex((plantilla) => plantilla?.campo === campo);

      if (index === -1) {
        return [
          ...lista,
          {
            campo,
            palabra_clave:
              propiedad === "palabra_clave"
                ? valor
                : OPCIONES_PALABRA_CLAVE[0],
            texto: propiedad === "texto" ? valor : "",
            habilitada: propiedad === "habilitada" ? valor : true,
          },
        ];
      }

       lista[index] = {
          ...lista[index],
          palabra_clave:
            lista[index]?.palabra_clave || OPCIONES_PALABRA_CLAVE[0],
          [propiedad]: valor,
        };

        return lista;
      });
    };
    
  const estaSeleccionada = (key) => seleccion.has(key);

  const toggleKey = (key) => {
    setSeleccionActual((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  const restaurarSugerenciaHistorica = (campo, valor) => {
  setConfigSugerenciasHistoricas((prev) => {
    const configActual = prev || {};
    const configCampo = configActual?.[campo] || {};

    const ocultosActuales = Array.isArray(configCampo.ocultos)
      ? configCampo.ocultos
      : [];

    const normalizar = (texto) =>
    String(texto || "")
      .trim()
      .replace(/\s+/g, " ");

    return {
      ...configActual,
      [campo]: {
        ...configCampo,
        ocultos: ocultosActuales.filter(
          (item) => normalizar(item) !== normalizar(valor)
        ),
      },
    };
  });
};

const cambiarNom024 = async (nuevoEstado) => {
  const mensaje = nuevoEstado
    ? "¿Deseas activar la versión certificada NOM-024?\n\n" +
      "Al confirmar, se activará automáticamente la versión certificada del expediente clínico de Salvir.\n\n" +
      "IMPORTANTE:\n" +
      "• Asegúrate de haber registrado o migrado todas tus consultas y expedientes clínicos anteriores que desees conservar en Salvir. Una vez activada, no podrás registrar consultas con una antigüedad mayor a 48 horas.\n\n" +
      "• Completa la información requerida en Gestión de Perfil y verifica que los datos de tus pacientes estén completos conforme a los requisitos de esta versión.\n\n" +
      "Los pacientes, expedientes y consultas que ya tengas registrados en Salvir se conservarán y no se eliminarán al realizar el cambio.\n\n" +
      "¿Deseas continuar con la activación?"

    : "¿Deseas desactivar la versión certificada NOM-024?\n\n" +
      "Al confirmar, se desactivará automáticamente la versión certificada del expediente clínico de Salvir.\n\n" +
      "Las nuevas consultas que registres no estarán bajo esta versión y su cumplimiento no será retroactivo si decides reactivarla posteriormente.\n\n" +
      "Tus pacientes, expedientes y consultas anteriores se conservarán.\n\n" +
      "¿Deseas continuar con la desactivación?";

 if (!window.confirm(mensaje)) return;

setGuardando(true);
setMensaje(null);
setError(null);

try {
  await updatePerfilMedico({
    nom024: nuevoEstado,
  });

  setNom024(nuevoEstado);

  setPerfil((prev) => ({
    ...(prev || {}),
    nom024: nuevoEstado,
  }));

  setMensaje(
    nuevoEstado
      ? "Versión certificada activada correctamente."
      : "Versión certificada desactivada correctamente."
  );

} catch (error) {
  console.error("Error actualizando NOM-024:", error);

  setError(
    "No se pudo actualizar la versión certificada. Intenta nuevamente."
  );

} finally {
  setGuardando(false);
}
};


  const guardar = async () => {
    try {
      setGuardando(true);
      setMensaje(null);
      setError(null);

      const plantillasAEnviar = (plantillasPersonalizadas || [])
  .map((plantilla) => ({
    ...plantilla,
    palabra_clave: String(
      plantilla?.palabra_clave || OPCIONES_PALABRA_CLAVE[0]
    ).trim(),
    texto: String(plantilla?.texto || "").trim(),
    habilitada: plantilla?.habilitada !== false,
  }))
  .filter((plantilla) => plantilla.texto !== "");

      const cfgActual = perfil?.config_cuestionario || {};
      const customActual = cfgActual?.custom || {};

      // 👇 Siempre guardamos ambos borradores, incluso si están vacíos
      const payloadHistoria = Array.from(seleccionHistoria);
      const payloadConsulta = Array.from(seleccionConsulta);

      const nextCustom = {
        ...customActual,
        historia: {
        ...(customActual.historia || {}),
        version: 1,
        selected_keys: payloadHistoria,
        capture_modes: captureModesHistoria,
      },
        consulta: { ...(customActual.consulta || {}), version: 1, selected_keys: payloadConsulta },
      };

      const nextConfig = { ...cfgActual, custom: nextCustom };

      await updatePerfilMedico({
       config_cuestionario: nextConfig,
       plantillas_habilitadas: plantillasHabilitadas,
       plantillas_personalizadas: plantillasAEnviar,
       sugerencias_historicas_habilitadas:sugerenciasHistoricasHabilitadas,
       config_sugerencias_historicas:configSugerenciasHistoricas,
       nom024: nom024,
       nom004: false,
     });

      // sincroniza estado local
      setPerfil((prev) => ({
      ...(prev || {}),
      config_cuestionario: nextConfig,
      plantillas_habilitadas: plantillasHabilitadas,
      plantillas_personalizadas: plantillasAEnviar,
      sugerencias_historicas_habilitadas:sugerenciasHistoricasHabilitadas,
      config_sugerencias_historicas:configSugerenciasHistoricas,
      nom024: nom024,
    }));

    setPlantillasPersonalizadas(plantillasAEnviar);

      setMensaje("Configuración guardada.");
    } catch (e) {
      console.error(e);
      setError("No se pudo guardar la configuración.");
    } finally {
      setGuardando(false);
    }
  };


  if (loading) {
    return (
      <div className="cq__wrap">
        <p>Cargando…</p>
      </div>
    );
  }

  return (
  <div className="cq__wrap">
    <h2>Configurar cuestionario</h2>

    {(mensaje || error) && (
      <div className={`cq__msg ${error ? "error" : "ok"}`}>
        {error || mensaje}
      </div>
    )}

    <div className="tabs-container">
      <div className="tabs-scroll">
        {RUBROS_CONFIG.map((rubro) => (
          <button
            key={rubro.id}
            type="button"
            className="tab"
            onClick={() => scrollToConfig(rubro.id)}
          >
            {rubro.label}
          </button>
        ))}
      </div>
    </div>

    {/* BLOQUE 1: CERTIFICADO NOM-024 */}
    <div className="cq__section">
      <div className="accordion">

        <div className="accordion-header cq__row--main">
          <span>Certificado NOM-024</span>

          <label className="switch" onClick={(e) => e.stopPropagation()}>
            <input
              type="checkbox"
              checked={nom024}
              onChange={(e) => cambiarNom024(e.target.checked)}
              disabled={guardando}
            />
            <span className="slider" />
          </label>
        </div>

        <div className="accordion-body">
          <p className="cq__helper cq__helper--block">
            Activa la versión certificada de Salvir conforme a la
            NOM-024-SSA3-2012 para utilizar el expediente clínico
            bajo esta modalidad.
          </p>

          <p className="cq__helper cq__helper--block">
            Una vez activada, completa la información requerida
            en Gestión de Perfil antes de comenzar a registrar
            atenciones bajo NOM-024.
          </p>

          <p className="cq__helper cq__helper--block">
            Los pacientes y expedientes anteriores se conservarán.
            La activación no otorga cumplimiento retroactivo
            a las atenciones registradas previamente.
          </p>
        </div>

      </div>
    </div>
    
    {/* BLOQUE 2: NOM-004 */}
    <div id="config-historia" className="cq__section">
      <div className="accordion">
        <div className="accordion-header cq__row--main">
          <span>Historia clínica</span>
          {/* hay que ver que hacemos con este switch, por ahora que se quede en true o false, no importa...
           <label className="switch" onClick={(e) => e.stopPropagation()}>
            <input
              type="checkbox"
              checked={nom004}
              onChange={(e) => setNom004(e.target.checked)}
            />
            <span className="slider" />
          </label>*/}
        </div>
        <div className="accordion-body">
        <p className="cq__helper cq__helper--block">
            Elige cómo quieres capturar cada sección de la historia clínica.
            En modo breve, verás un solo campo libre para escribir el resumen.
            En modo detallado, Salvir mostrará campos guiados para ordenar mejor la captura durante la consulta.
          </p>

          <p className="cq__helper cq__helper--example">
            Ejemplo: en Interrogatorio por aparatos y sistemas, el modo breve muestra un solo campo para escribir todo el interrogatorio; 
            el modo detallado separa la captura en sistema nervioso, cardiovascular, respiratorio, digestivo, 
            genitourinario, musculoesquelético, endocrino, hematológico, piel y anexos.
          </p>

          <div className="cq__row cq__row--sub">
            <span className="cq__label">Antecedentes heredofamiliares</span>
            <span className="cq__helper">Breve   / Detallado</span>
            <label className="switch">
              <input
                type="checkbox"
                checked={captureModesHistoria.heredofamiliares === "detallado"}
                onChange={(e) =>
                  setCaptureModesHistoria((prev) => ({
                    ...prev,
                    heredofamiliares: e.target.checked ? "detallado" : "breve",
                  }))
                }
              />
              <span className="slider" />
            </label>
          </div>
          <div className="cq__row cq__row--sub">
            <span className="cq__label">Antecedentes no patológicos</span>
            <span className="cq__helper">Breve   / Detallado</span>
            <label className="switch">
              <input
                type="checkbox"
                checked={captureModesHistoria.no_patologicos === "detallado"}
                onChange={(e) =>
                  setCaptureModesHistoria((prev) => ({
                    ...prev,
                    no_patologicos: e.target.checked ? "detallado" : "breve",
                  }))
                }
              />
              <span className="slider" />
            </label>
          </div>

          <div className="cq__row cq__row--sub">
            <span className="cq__label">Antecedentes patológicos</span>
            <span className="cq__helper">Breve   / Detallado</span>
            <label className="switch">
              <input
                type="checkbox"
                checked={captureModesHistoria.patologicos === "detallado"}
                onChange={(e) =>
                  setCaptureModesHistoria((prev) => ({
                    ...prev,
                    patologicos: e.target.checked ? "detallado" : "breve",
                  }))
                }
              />
              <span className="slider" />
            </label>
          </div>

          <div className="cq__row cq__row--sub">
            <span className="cq__label">Interrogatorio por aparatos y sistemas</span>
            <span className="cq__helper">Breve   / Detallado</span>
            <label className="switch">
              <input
                type="checkbox"
                checked={captureModesHistoria.interrogatorio === "detallado"}
                onChange={(e) =>
                  setCaptureModesHistoria((prev) => ({
                    ...prev,
                    interrogatorio: e.target.checked ? "detallado" : "breve",
                  }))
                }
              />
              <span className="slider" />
            </label>
          </div>
        </div>
      </div>
    </div>
    
    {/* BLOQUE: PLANTILLAS RÁPIDAS */}
    <div id="config-plantillas" className="cq__section">
      <div className="accordion">

        <div className="accordion-header cq__row--main">
          <span>Plantillas rápidas</span>

          <label className="switch" onClick={(e) => e.stopPropagation()}>
            <input
              type="checkbox"
              checked={plantillasHabilitadas}
              onChange={(e) => setPlantillasHabilitadas(e.target.checked)}
            />
            <span className="slider" />
          </label>
        </div>

        <div className="accordion-body">

         <p className="cq__helper cq__helper--block">
          Crea plantillas para agilizar la captura de datos y hacer tus consultas más
          fáciles y rápidas. Para utilizar una plantilla durante la consulta, escribe
          la palabra clave asignada en el campo correspondiente que es: <strong>plantilla</strong>. Al escribirla, Salvir te mostrará
          la opción de insertar el texto que hayas guardado aquí para utilizarlo en
          las consultas que generes para cualquiera de tus pacientes.
        </p>

          <br />

          <p className="cq__helper cq__helper--block">
            <strong>Importante:</strong> Las plantillas son una herramienta de apoyo
            para agilizar la documentación. Revisa y ajusta siempre el contenido de
            acuerdo con los hallazgos de cada paciente antes de guardar la consulta.
          </p>

          {plantillasHabilitadas && (
            <>
              <br />

              

              <br />

              {camposPlantilla.map(({ campo, label }) => {
                const plantilla = obtenerPlantillaCampo(campo);

                return (
                  <div
                    key={campo}
                    className="accordion cq__subaccordion"
                  >
                    <div className="accordion-header cq__row--main">
                      <span>{label}</span>

                      <label
                        className="switch"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <input
                          type="checkbox"
                          checked={plantilla ? plantilla.habilitada !== false : true}
                          onChange={(e) =>
                            actualizarPlantillaCampo(
                              campo,
                              "habilitada",
                              e.target.checked
                            )
                          }
                        />
                        <span className="slider" />
                      </label>
                    </div>

                    {(!plantilla || plantilla.habilitada !== false) && (
                      <div className="accordion-body">
                        {!CAMPOS_SIN_MODO.some((item) => item.campo === campo) && (
                          <p className="cq__helper cq__helper--block">
                            Actualmente utilizas el modo{" "}
                            <strong>
                              {obtenerModoPlantilla(campo) === "detallado"
                                ? "detallado"
                                : "breve"}
                            </strong>
                            . Configura una plantilla para cada campo que quieras prellenar.
                          </p>
                        )}

                      <div className="cq__meta">

                        <label className="cq__label">
                          Palabra clave
                        </label>

                        <select
                        className="cq__plantilla-control"
                          value={
                            plantilla?.palabra_clave || OPCIONES_PALABRA_CLAVE[0]
                          }
                          onChange={(e) =>
                            actualizarPlantillaCampo(
                              campo,
                              "palabra_clave",
                              e.target.value
                            )
                          }
                        >
                          {OPCIONES_PALABRA_CLAVE.map((opcion) => (
                            <option key={opcion} value={opcion}>
                              {opcion}
                            </option>
                          ))}
                        </select>

                        <br />
                        <label className="cq__label">
                          Texto de la plantilla
                        </label>

                     {[
                          "interrogatorio_consolidado",
                          "heredofamiliares_consolidado",
                          "no_patologicos_consolidado",
                          "patologicos_consolidado",
                          "patologicos_ECD",
                          "exploracion_fisica",
                          "pronostico",
                          "planTratamiento",
                        ].includes(campo) ? (
                        <textarea
                          className="cq__plantilla-control cq__plantilla-textarea"
                          rows={4}
                          placeholder={obtenerPlaceholderPlantilla(campo)}
                          value={plantilla?.texto || ""}
                          onChange={(e) =>
                            actualizarPlantillaCampo(
                              campo,
                              "texto",
                              e.target.value  
                            )
                          }
                        />
                      ) : (
                        <input
                          className="cq__plantilla-control"
                          type="text"
                          placeholder={obtenerPlaceholderPlantilla(campo)}
                          value={plantilla?.texto || ""}
                          onChange={(e) =>
                            actualizarPlantillaCampo(
                              campo,
                              "texto",
                              e.target.value
                            )
                          }
                        />
                      )}

                      </div>

                    </div>
                    )}
                  </div>
                );
              })}

            </>
          )}

        </div>
      </div>
    </div>

    {/* BLOQUE 3: PREGUNTAS OPCIONALES */}
    <div id="config-opcionales" className="cq__section">
      <div className="accordion">
        <div
          className="accordion-header"
          onClick={() => setShowOpcionales((prev) => !prev)}
        >
          <span>Preguntas opcionales</span>
          <span className={`chev ${showOpcionales ? "open" : ""}`}>▼</span>
        </div>

        {showOpcionales && (
          <div className="accordion-body">
             <h4>
              Personaliza las preguntas opcionales de{" "}
              <strong>
                {scope === SCOPES.HISTORIA
                  ? "alta historia clínica y consulta inicial"
                  : "consulta de seguimiento"}
              </strong>
              . El cuestionario general ya viene incluido, marca las preguntas adicionales que quieras agregar según tu práctica médica.
            </h4>
            <div className="cq__tabs">
              <button
                className={`tab ${scope === SCOPES.HISTORIA ? "active" : ""}`}
                onClick={() => setScope(SCOPES.HISTORIA)}
                type="button"
              >
                Historia clínica y consulta inicial
              </button>
              <button
                className={`tab ${scope === SCOPES.CONSULTA ? "active" : ""}`}
                onClick={() => setScope(SCOPES.CONSULTA)}
                type="button"
              >
                Consulta de seguimiento
              </button>
            </div>

            {ESPECIALIDADES.map((esp) => {
              const items =
                (scope === SCOPES.HISTORIA ? CATALOGO : CATALOGO_CONSULTA)[esp] || [];

              if (!items.length) return null;

              return (
                <div key={esp} className="accordion cq__subaccordion">
                  <div
                    className="accordion-header"
                    onClick={() => setOpenSubs((prev) => {
                      const next = new Set(prev);
                      if (next.has(esp)) next.delete(esp);
                      else next.add(esp);
                      return next;
                    })}
                  >
                   <span>
                      {{
                        ginecologia: "Ginecología",
                        pediatria: "Pediatría",
                        geriatria: "Geriatría",
                      }[esp] || (esp.charAt(0).toUpperCase() + esp.slice(1))}
                    </span>
                    <span className={`chev ${openSubs.has(esp) ? "open" : ""}`}>▼</span>
                  </div>

                  {openSubs.has(esp) && (
                  <div className="accordion-body">
                    <div className="cq__list">
                      {items.map((item) => (
                        <label key={item.key} className="cq__item">
                          <input
                            type="checkbox"
                            checked={estaSeleccionada(item.key)}
                            onChange={() => toggleKey(item.key)}
                          />
                          <div className="cq__meta">
                            <div className="cq__title">{item.label}</div>
                          </div>
                        </label>
                      ))}
                    </div>
                  </div>
               
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
    
    {/* BLOQUE: SUGERENCIAS HISTÓRICAS */}
    <div id="config-historicos" className="cq__section">
      <div className="accordion">

        <div className="accordion-header cq__row--main">
          <span>Sugerencias históricas</span>

          <label
            className="switch"
            onClick={(e) => e.stopPropagation()}
          >
            <input
              type="checkbox"
              checked={sugerenciasHistoricasHabilitadas}
              onChange={(e) =>
                setSugerenciasHistoricasHabilitadas(e.target.checked)
              }
            />
            <span className="slider" />
          </label>
        </div>

        <div className="accordion-body">
          <div className="cq__meta">
            <p className="cq__helper cq__helper--block">
              <strong>Salvir aprende de la forma en que capturas tus consultas.</strong>{" "}
              Cuando utilizas con frecuencia un mismo medicamento, posología o diagnóstico,
              puede volver a sugerírtelo al comenzar a escribir sus primeras 3 letras para
              ayudarte a capturar la información más rápido.
            </p>

            <p className="cq__helper cq__helper--block">
              Actualmente, las sugerencias históricas están disponibles para{" "}
              <strong>medicamentos, posologías y diagnósticos</strong>. Una opción comienza
              a sugerirse después de haber sido utilizada al menos 3 veces.
            </p>

            <p className="cq__helper cq__helper--block">
              Puedes activar o desactivar esta función con el interruptor superior.
              Si la desactivas, Salvir simplemente dejará de mostrar sugerencias históricas;
              no se eliminará información de tus consultas ni las opciones que hayas ocultado.
            </p>
          </div>
             <br />
           {/* ADMINISTRAR OPCIONES OCULTAS */}
          <div className="accordion cq__subaccordion">
            <div
              className="accordion-header"
              onClick={() =>
                setShowHistoricosOcultos((prev) => !prev)
              }
            >
              <span>Administrar opciones ocultas</span>

              <span
                className={`chev ${showHistoricosOcultos ? "open" : ""}`}
              >
                ▼
              </span>
            </div>

            {showHistoricosOcultos && (
              <div className="accordion-body">

                <p className="cq__helper cq__helper--block">
                  Aquí puedes revisar las sugerencias que decidiste ocultar.
                  Mientras una opción permanezca oculta, no volverá a aparecer
                  al escribir sus primeras 3 letras. Si quieres volver a recibirla
                  como sugerencia, selecciona <strong>Restaurar</strong>.
                </p>

                <br />

                {[
                  {
                    campo: "medicamentos",
                    label: "Medicamentos",
                  },
                  {
                    campo: "posologia",
                    label: "Posología",
                  },
                  {
                    campo: "diagnosticos",
                    label: "Diagnósticos",
                  },
                ].map(({ campo, label }) => {
                  const ocultos = Array.isArray(
                    configSugerenciasHistoricas?.[campo]?.ocultos
                  )
                    ? configSugerenciasHistoricas[campo].ocultos
                    : [];

                  const abierto = openHistoricos.has(campo);

                  return (
                    <div
                      key={campo}
                      className="accordion cq__subaccordion"
                    >
                      <div
                        className="accordion-header"
                        onClick={() =>
                          setOpenHistoricos((prev) => {
                            const next = new Set(prev);

                            if (next.has(campo)) {
                              next.delete(campo);
                            } else {
                              next.add(campo);
                            }

                            return next;
                          })
                        }
                      >
                        <span>
                          {label}{" "}
                          <span className="cq__helper">
                            ({ocultos.length})
                          </span>
                        </span>

                        <span
                          className={`chev ${abierto ? "open" : ""}`}
                        >
                          ▼
                        </span>
                      </div>

                      {abierto && (
                        <div className="accordion-body">

                          {ocultos.length > 0 ? (
                            <div className="cq__historicos-lista">
                              {ocultos.map((valor) => (
                                <div
                                  key={valor}
                                  className="cq__row cq__row--sub"
                                >
                                  <span className="cq__label">
                                    {valor}
                                  </span>

                                  <button
                                    type="button"
                                    onClick={() =>
                                      restaurarSugerenciaHistorica(
                                        campo,
                                        valor
                                      )
                                    }
                                  >
                                    Restaurar
                                  </button>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p className="cq__helper cq__helper--block">
                              No has ocultado ninguna opción.
                            </p>
                          )}

                        </div>
                      )}
                    </div>
                  );
                })}

              </div>
            )}
          </div>
        </div>

      </div>
    </div>

    <footer className="cq__footer">
      <button
        className="btn primary"
        onClick={guardar}
        disabled={guardando}
        type="button"
      >
        {guardando ? "Guardando…" : "Guardar"}
      </button>
    </footer>
  </div>
);
}
